export const CustomErrorType = {
    HTTP: 1,
    OTHER: 2
};
